import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const steps = [{
  step: "Schritt 1",
  title: "Persönliche Beratung",
  description: "Wir besprechen deine Ziele und führen eine kurze Analyse durch.",
  image: {
    src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/WhatsApp-Image-2026-01-03-at-17.14.23-32.jpeg?v=yt19zrej2qn",
    srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/WhatsApp-Image-2026-01-03-at-17.14.23-32.jpeg?v=uu5v8dhn09-wvc-srcset",
    sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/WhatsApp-Image-2026-01-03-at-17.14.23-32.jpeg?v=8lvufkywg4w-wvc-sizes",
    alt: "Persönliche Beratung"
  }
}, {
  step: "Schritt 2",
  title: "Deine Anwendung",
  description: "Du liegst entspannt, während wir die speziellen Paddels an deinen Problemzonen platzieren.",
  image: {
    src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/BC_Abnehmen-im-Liegen3.jpg?v=n79gzljfh1n",
    srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/BC_Abnehmen-im-Liegen3.jpg?v=kimwgqry0ih-wvc-srcset",
    sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/BC_Abnehmen-im-Liegen3.jpg?v=h9e0tjalzw-wvc-sizes",
    alt: "Deine Anwendung"
  }
}, {
  step: "Schritt 3",
  title: "Nachruhe:",
  description: "Dein Stoffwechsel ist nun für ca. 24 Stunden aktiv. In dieser Zeit arbeitet dein Körper auf Hochtouren weiter.",
  image: {
    src: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/Bodyconcept_linda_bewei.png?v=vqfcnh24x7",
    srcset: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/Bodyconcept_linda_bewei.png?v=dwbrdfvvmfm-wvc-srcset",
    sizes: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/Bodyconcept_linda_bewei.png?v=30kdzj273o6-wvc-sizes",
    alt: "Sichtbare Resultate"
  }
}];
export default function HowItWorksProcess() {
  return <section data-section-id="253331" id="treatmentprocessflow" className="light !text-transparent !bg-[rgba(243,232,255,0.01)]">
      <div className="from-accent to-background py-32 px-4 !bg-[rgba(255,213,252,0.24)] sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-32 font-default !text-[rgba(166,5,165,1)] md:text-5xl">
            Der Ablauf – Was dich erwartet
          </h2>
          
          <div className="flex flex-col lg:flex-row gap-32 lg:gap-8 justify-center items-center lg:items-stretch mt-12">
            {steps.map((step, index) => <Card key={index} data-index={index} className="bg-card rounded-2xl shadow-xl relative pt-32 pb-10 px-6 text-center flex-1 w-full max-w-md border-none overflow-visible transition-all duration-300 hover:shadow-2xl">
                <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-48 h-48 rounded-lg border-8 border-background shadow-lg overflow-hidden bg-muted">
                  <img src={step.image.src} data-wvc-srcset={step.image.srcset} data-wvc-sizes={step.image.sizes} alt={step.image.alt} className="object-cover !w-[230px] !h-[190px]" loading="lazy" />
                </div>
                
                <CardHeader className="p-0 mb-4">
                  <div className="text-primary font-bold text-lg uppercase tracking-widest mb-2 font-default">
                    {step.step}
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground font-default">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="p-0">
                  <p className="text-muted-foreground leading-relaxed font-default !text-lg">
                    {step.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}